export default {
  install: function (Vue) {
    Vue.prototype.$replacePlaceholders = function (htmlStr, availableData) {
      htmlStr = htmlStr
        .replace(
          '{productName}',
          `<span dir="ltr">${availableData.productName}</span>`
        )
        .replace('{msisdn}', availableData.msisdn)
        .replace('{trialPeriod}', availableData.trialPeriod)
        .replace('{frequency}', availableData.frequency)
        .replace('{freeStartPeriod}', availableData.freeStartPeriod)
        .replace('{price}', availableData.price)
        .replace('{currency}', availableData.currency)
        .replace('{cancelKeyword}', availableData.cancelKeyword)
        .replace('{cancelShortCode}', availableData.cancelShortCode)
        .replace('{renewalDate}', availableData.renewalDate);
      return htmlStr.includes('undefined') || htmlStr.includes('null')
        ? ''
        : htmlStr;
    };
  },
};
